document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.archive-records-section').forEach(initArchiveSection);
});

function initArchiveSection(section) {

  const grid = section.querySelector('[data-record-grid]');

  if (!grid) return;

  const cards = [...grid.querySelectorAll('.archive-record-card')];
  const originalCards = [...cards];
  const tabs = [...section.querySelectorAll('.archive-tab')];
  const sortSelect = section.querySelector('select');
  const pagination = section.querySelector('[data-pagination]');
  const pageNumbers = section.querySelector('[data-page-numbers]');
  const prevBtn = section.querySelector('[data-prev]');
  const nextBtn = section.querySelector('[data-next]');
  const displayCount = section.querySelector('[data-display-count]');
  const recordsPerPage = Number(
    section.dataset.recordsPerPage || 12
  );

  const enablePagination =
    section.dataset.enablePagination === 'true';

  let currentCategory = 'all';
  let currentPage = 1;
  let filtered = [...cards];
function applyCategory() {
  filtered = originalCards.filter(card => {
    if (currentCategory === 'all') {
      return true;
    }
    return card.dataset.category === currentCategory;
  });
}

  function applySort() {
    if (!sortSelect) return;
    if (!sortSelect.value) return;
    switch (sortSelect.value) {
    case 'oldest':
    filtered.sort((a,b)=>{
        return (
        new Date(a.dataset.date)
        -
        new Date(b.dataset.date)
        );
    });

    break;
    case 'latest':
    filtered.sort((a,b)=>{
        return (
        new Date(b.dataset.date)
        -
        new Date(a.dataset.date)
        );
    });

    break;
      case 'az':
        filtered.sort(
          (a,b)=>
          a.dataset.title.localeCompare(
            b.dataset.title
          )
        );

      break;
      case 'za':
        filtered.sort(
          (a,b)=>
          b.dataset.title.localeCompare(
            a.dataset.title
          )
        );

      break;
    }
  }

  function renderPagination() {
    if (!enablePagination || !pagination)
      return;

    const pages =
      Math.ceil(
        filtered.length / recordsPerPage
      );

    pageNumbers.innerHTML = '';
    if (pages <= 1) {
      pagination.style.display = 'none';
      return;
    }

    pagination.style.display = 'flex';

    for (
      let i = 1;
      i <= pages;
      i++
    ) {

      const btn =
        document.createElement('button');
      btn.type = 'button';
      btn.textContent = i;
      if (i === currentPage) {
        btn.classList.add('active');
      }

      btn.addEventListener(
        'click',
        () => {
          currentPage = i;
          render();
        }
      );

      pageNumbers.append(btn);
    }

    prevBtn.disabled =
      currentPage === 1;
    nextBtn.disabled =
      currentPage === pages;

  }

  function renderCards() {
    cards.forEach(
      card => card.classList.add('hidden')
    );

    filtered.forEach(card => {

      grid.appendChild(card);

    });

    let start = 0;
    let end = filtered.length;
    if (enablePagination) {
      start =
        (currentPage - 1)
        *
        recordsPerPage;
      end =
        start
        +
        recordsPerPage;
    }

    filtered.forEach(
      (card,index)=>{

        if (
          index >= start
          &&
          index < end
        ) {

          card.classList.remove(
            'hidden'
          );

        }

      }
    );

    updateCounter(
      start,
      end
    );

  }

  function updateCounter(
    start,
    end
  ) {

    if (!displayCount)
      return;

    const visibleStart =
      filtered.length
      ?
      start + 1
      :
      0;

    const visibleEnd =
      Math.min(
        end,
        filtered.length
      );

    displayCount.textContent =
      `Displaying ${visibleStart}–${visibleEnd} of ${filtered.length} records`;

  }

  function render() {
    applyCategory();
    applySort();
    renderCards();
    renderPagination();

  }

  tabs.forEach(tab => {

    tab.addEventListener(
      'click',
      () => {

        tabs.forEach(
          x=>x.classList.remove(
            'is-active'
          )
        );

        tab.classList.add(
          'is-active'
        );
        currentCategory =
          tab.dataset.category;
        currentPage = 1;
        render();

      }
    );

  });

  if (sortSelect) {
    sortSelect.addEventListener(
      'change',
      () => {
        currentPage = 1;
        render();
      }
    );

  }

  if (prevBtn) {

    prevBtn.addEventListener(
      'click',
      () => {
        if (
          currentPage > 1
        ) {
          currentPage--;
          render();
        }
      }
    );
  }
  if (nextBtn) {

    nextBtn.addEventListener(
      'click',
      () => {
        const pages =
          Math.ceil(
            filtered.length
            /
            recordsPerPage
          );
        if (
          currentPage < pages
        ) {
          currentPage++;
          render();
        }
      }
    );
  }
  render();
}